
// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function Popular({ refreshCart, selectedBrands = [], filterByBrands }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});

//   const itemsPerPage = 4;
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();

//   // ✅ Fetch all data
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ Filter products when selectedBrands changes
//   useEffect(() => {
//     console.log("Filtering Deals of the Day...");
//     console.log("Selected brands:", selectedBrands);
//     console.log("All products:", getProduct);
    
//     if (getProduct.length > 0) {
//       let filtered;
//       if (filterByBrands) {
//         filtered = filterByBrands(getProduct);
//       } else {
//         // Fallback filtering if filterByBrands is not provided
//         if (selectedBrands.length === 0) {
//           filtered = getProduct;
//         } else {
//           filtered = getProduct.filter(product => {
//             console.log(`Product: ${product.title}, Brand: ${product.brand_name}`);
//             return product.brand_name && selectedBrands.includes(product.brand_name);
//           });
//         }
//       }
      
//       console.log("Filtered products:", filtered);
//       setFilteredProducts(filtered);
//       // Reset current slide when products change
//       setCurrentSlide(0);
//     }
//   }, [getProduct, selectedBrands, filterByBrands]);

//   const fetchData = async () => {
//     try {
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       // Fetch deal of the day products
//       const popularRes = await fetch(
//         "https://backend.frozenwala.com/api/deal-of-the-day/"
//       );
//       const popularData = await popularRes.json();
      
//       console.log("Deals of the Day items:", popularData);
//       // Check if products have brand_name field
//       if (popularData.length > 0) {
//         console.log("Sample product fields:", Object.keys(popularData[0]));
//         console.log("Sample product brand_name:", popularData[0].brand_name);
//       }
      
//       setGetProduct(popularData);

//       try {
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       } catch (stockErr) {
//         console.error("Error fetching stock data:", stockErr);
//       }

//       // Only fetch cart if user is logged in
//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach(
//               (item) => (cartMap[item.product_id] = item.quantity)
//             );
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log(
//             "User not logged in or token expired, skipping cart/stock"
//           );
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     }
//   };

//   // ✅ Auto slide carousel
//   useEffect(() => {
//     if (filteredProducts.length > 0) {
//       const interval = setInterval(() => handleScroll("next"), 3500);
//       return () => clearInterval(interval);
//     }
//   }, [filteredProducts]);

//   const handleScroll = (direction) => {
//     if (filteredProducts.length === 0) return;
//     const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next"
//         ? (prev + 1) % totalSlides
//         : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   const visibleItems = [];
//   for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
//     visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
//   }

//   // ✅ Add to cart logic
//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   // ✅ Increase/Decrease quantity
//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId];

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, {
//           product_id: productId,
//           user_id: uid,
//         });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, {
//         product_id: productId,
//         user_id: uid,
//       });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   // Show message when no products match the selected brands
//   if (filteredProducts.length === 0 && getProduct.length > 0) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center">
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//             style={{ textAlign: "left" }}
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             Deals of the Day
//           </motion.h5>
//           <div className="text-center py-5">
//             <p>No deals match the selected brand filters.</p>
//             <p className="text-muted small">Try selecting different brands.</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="popular-section py-4 overflow-hidden">
//       <div className="container text-center">
//         <motion.h5
//           className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//           style={{textAlign: "left"}}
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           Deals of the Day
//         </motion.h5>

//         {filteredProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <p>Loading deals...</p>
//           </div>
//         ) : (
//           <div className="position-relative">
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={currentSlide}
//                 className="row gx-4"
//                 initial={{ opacity: 0, x: 100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -100 }}
//                 transition={{ duration: 0.6 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   // const isSoldOut = stock[item.id] === 0;
//                   const isSoldOut = item.stock === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <motion.div
//                       key={item.id}
//                       className="col-6 col-sm-6 col-md-4 col-lg-3"
//                     >
//                       <div className="card card-span border-0 h-70 p-0 rounded-4 position-relative small-card">
//                         {/* Sold out badge */}
//                         {isSoldOut && (
//                           <div className="sold-out-badge">Sold Out</div>
//                         )}

//                         {/* ❤️ Wishlist Icon */}
//                         <div
//                           onClick={() => !wishlistLoading && toggleWishlist(item)}
//                           style={{
//                             position: "absolute",
//                             top: "15px",
//                             right: "15px",
//                             cursor: "pointer",
//                           }}
//                         >
//                           {isInWishlist ? (
//                             <FaHeart size={26} color="red" />
//                           ) : (
//                             <CiHeart size={26} color="#bbb" />
//                           )}
//                         </div>

//                         <motion.img
//                           src={item.item_photo || logo}
//                           alt={item.title}
//                           className="img-fluid rounded-4 w-100 popular-img"
//                           style={{ cursor: "pointer" }}
//                           transition={{ duration: 0.4 }}
//                           onClick={() => navigate(`products/${item.id}`)}
//                         />

//                         <div className="card-body px-0 text-center">                         
//                           <h6
//                             className="fw-bold text-truncate"
//                             style={{ textAlign: "left" }}
//                           >
//                             {item.title}
//                           </h6>
//                           <div
//                             style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}
//                           >
//                             <p
//                               className="old-price"
//                               style={{
//                                 textDecoration: `${item.item_old_price === item.item_new_price ? "auto" : "line-through"}`,
//                                 color: "#999",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               ₹{item.item_old_price || 0}
//                             </p>
//                             <p className="fw-bold" style={{fontSize: "0.83333rem"}}>
//                               ₹{item.item_new_price}
//                             </p>

//                             <p
//                               className="discount-badge"
//                               style={{
//                                 color: "green",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               {item.discount_percentage}% OFF
//                             </p>
//                           </div>
//                           {cartQty && !isSoldOut && isLoggedIn ? (
//                             <div className="d-flex justify-content-center align-items-center gap-2">
//                               <button
//                                 className="qty-btn"
//                                 onClick={() => subOne(item.id)}
//                               >
//                                 -
//                               </button>
//                               <span className="fw-bold">
//                                 {cartQty}
//                               </span>
//                               <button
//                                 className="qty-btn"
//                                 onClick={() => addOne(item.id)}
//                               >
//                                 +
//                               </button>
//                             </div>
//                           ) : (
//                             <button
//                               className="btn btn-danger btn-sm rounded-pill"
//                               onClick={() => onPressAddToCart(item.id)}
//                               disabled={isSoldOut}
//                               style={{padding: "6px 12px", fontSize: "12px"}}
//                             >
//                               Add to Cart
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     </motion.div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;

// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import {
//   FaChevronLeft,
//   FaChevronRight,
//   FaTags,
//   FaFire,
//   FaStore,
//   FaShoppingCart,
//   FaLeaf,
//   FaDrumstickBite,
//   FaStar,
// } from "react-icons/fa";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";

// function DealsOfTheDay({ refreshCart, selectedBrands = [] }) {
//   const [products, setProducts] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const uid = localStorage.getItem("user_id");

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       let url = "https://backend.frozenwala.com/api/deal-of-the-day/";
//       if (selectedBrands && selectedBrands.length > 0) {
//         url += `?brand=${encodeURIComponent(selectedBrands.join(","))}`;
//       }
//       const res = await fetch(url);
//       const data = await res.json();
//       setProducts(Array.isArray(data) ? data : []);
//       setCurrentIndex(0);
//     } catch (err) {
//       console.error("Error loading deals:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrev = (e) => {
//     e.stopPropagation();
//     if (products.length === 0) return;
//     setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
//   };

//   const handleNext = (e) => {
//     e.stopPropagation();
//     if (products.length === 0) return;
//     setCurrentIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
//   };

//   const onOrderNow = async (e, productId) => {
//     e.stopPropagation();
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       refreshCart();
//       navigate("/cart");
//     } catch (err) {
//       console.error("Quick order failure", err);
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         className="card h-100 border-0 p-4 deals-card"
//         style={{
//           borderRadius: "28px",
//           minHeight: "440px",
//           backgroundColor: "#fff",
//           boxShadow: "0 25px 50px -12px rgba(0,0,0,0.08)",
//         }}
//       >
//         <div
//           className="placeholder-glow w-50 mb-3"
//           style={{ height: "24px", background: "#f0f0f0", borderRadius: "6px" }}
//         />
//         <div
//           className="w-100 flex-grow-1"
//           style={{ background: "#f8f9fa", borderRadius: "20px" }}
//         />
//       </div>
//     );
//   }

//   if (products.length === 0) return null;
//   const currentItem = products[currentIndex];

//   // Helper for veg/non-veg
//   const isNonVeg = currentItem.non_veg === true;
//   const VegIcon = isNonVeg ? FaDrumstickBite : FaLeaf;
//   const vegColor = isNonVeg ? "#5dc5fa" : "#2e7d32";
//   const vegLabel = isNonVeg ? "Non-Veg" : "Veg";
//   const vegBg = isNonVeg ? "rgba(211,47,47,0.1)" : "rgba(46,125,50,0.1)";

//   return (
//     <div
//       className="card h-100 border-0 p-4 deals-premium-card-popup deals-card"
//       style={{
//         borderRadius: "28px",
//         background:
//           "linear-gradient(145deg, #ffffff 0%, #fafbfc 100%)",
//         cursor: "pointer",
//         boxShadow:
//           "0 25px 60px -15px rgba(0, 0, 0, 0.12), 0 4px 20px -2px rgba(0, 0, 0, 0.03)",
//         border: "1px solid rgba(241, 114, 40, 0.08)",
//         transition:
//           "transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
//         position: "relative",
//         overflow: "visible",
//       }}
//       onClick={() => navigate(`products/${currentItem.id}`)}
//     >
//       {/* Subtle glow background accent */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-40px",
//           right: "-30px",
//           width: "120px",
//           height: "120px",
//           background:
//             "radial-gradient(circle, rgba(241,114,40,0.15) 0%, transparent 70%)",
//           borderRadius: "50%",
//           zIndex: 0,
//           pointerEvents: "none",
//         }}
//       />

//       {/* Expanded Vertical Showcase Image Area with polished shine */}
//       <div
//         className="position-relative w-100 mb-4 premium-shine-frame deal-image-wrapper"
//         style={{
//           height: "300px",
//           borderRadius: "20px",
//           overflow: "hidden",
//           boxShadow:
//             "0 12px 28px -6px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.02)",
//           zIndex: 2,
//         }}
//       >
//         {/* Responsive Badge Container */}
//         <div className="deal-badges-meta-container">
//           {/* Glassmorphism Title Overlay – now more vibrant */}
//           <div
//             className="d-flex align-items-center gap-2 deal-badge-left"
//             style={{
//               background: "rgba(255, 255, 255, 0.85)",
//               backdropFilter: "blur(16px)",
//               WebkitBackdropFilter: "blur(16px)",
//               border: "1px solid rgba(255, 255, 255, 0.5)",
//               padding: "8px 16px",
//               borderRadius: "100px",
//               boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
//             }}
//           >
//             <motion.div
//               animate={{ scale: [1, 1.25, 1] }}
//               transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
//               style={{ display: "flex", alignItems: "center", transform: "translateY(-2px)" }}
//             >
//               <FaFire color="#5dc5fa" size={20} />
//             </motion.div>
//             <span
//               className="fw-bold text-dark deal-badge-text"
//               style={{ fontSize: "16px", letterSpacing: "-0.2px" }}
//             >
//               Deals of the Day
//             </span>
//           </div>

//           {/* Limited Offers Status Pill – more vivid */}
//           <div
//             className="d-flex align-items-center gap-1.5 deal-badge-right"
//             style={{
//               background: "linear-gradient(135deg, #212529 0%, #343a40 100%)",
//               padding: "8px 14px",
//               borderRadius: "100px",
//               color: "#fff",
//               fontSize: "11px",
//               fontWeight: "600",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
//             }}
//           >
//             <FaTags size={11} color="#5dc5fa" /> Limited Offers
//           </div>
//         </div>

//         {/* Discount Overlay – ribbon style */}
//         {currentItem.discount_percentage && (
//           <div
//             className="position-absolute text-white fw-bold px-3 py-2 text-center shadow deal-discount-tag"
//             style={{
//               bottom: "20px",
//               left: "16px",
//               background: "linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%)",
//               borderRadius: "14px",
//               zIndex: 4,
//               fontSize: "14px",
//               letterSpacing: "0.5px",
//               lineHeight: "1.2",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               boxShadow: "0 8px 18px rgba(241, 114, 40, 0.45)",
//               border: "1px solid rgba(255,255,255,0.2)",
//             }}
//           >
//             <span style={{ fontSize: "18px", fontWeight: 800 }}>
//               {currentItem.discount_percentage}%
//             </span>
//             <span style={{ fontSize: "10px", opacity: 0.9 }}>OFF</span>
//             {/* little sparkle */}
//             <FaStar
//               size={10}
//               style={{ position: "absolute", top: "-6px", right: "-6px", color: "#FFD700" }}
//             />
//           </div>
//         )}

//         {products.length > 1 && (
//           <>
//             <button
//               onClick={handlePrev}
//               className="btn d-flex align-items-center justify-content-center p-0 shadow premium-arrow-nav arrow-left"
//               style={{
//                 position: "absolute",
//                 left: "14px",
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 width: "38px",
//                 height: "36px",
//                 borderRadius: "50%",
//                 zIndex: 5,
//                 border: "none",
//                 backgroundColor: "#ffffff",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//               }}
//             >
//               <FaChevronLeft size={11} color="#212529" />
//             </button>
//             <button
//               onClick={handleNext}
//               className="btn d-flex align-items-center justify-content-center p-0 shadow premium-arrow-nav arrow-right"
//               style={{
//                 position: "absolute",
//                 right: "14px",
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 width: "38px",
//                 height: "36px",
//                 borderRadius: "50%",
//                 zIndex: 5,
//                 border: "none",
//                 backgroundColor: "#ffffff",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//               }}
//             >
//               <FaChevronRight size={11} color="#212529" />
//             </button>
//           </>
//         )}

//         <AnimatePresence mode="wait">
//           <motion.img
//             key={currentItem.id}
//             src={currentItem.item_photo || logo}
//             alt={currentItem.title}
//             className="w-100 h-100"
//             style={{ objectFit: "cover" }}
//             initial={{ opacity: 0, scale: 1.03 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.97 }}
//             transition={{ duration: 0.25 }}
//           />
//         </AnimatePresence>
//       </div>

//       {/* Structured Content Metadata */}
//       <div className="d-flex justify-content-between align-items-start px-1 mb-2 deal-info-row">
//         <div className="deal-title-col" style={{ maxWidth: "70%", flex: 1 }}>
//           <h5
//             className="fw-bold text-dark mb-1 deal-item-title"
//             style={{
//               fontSize: "17px",
//               letterSpacing: "-0.2px",
//               lineHeight: 1.3,
//               display: "-webkit-box",
//               WebkitLineClamp: 2,
//               WebkitBoxOrient: "vertical",
//               overflow: "hidden",
//             }}
//           >
//             {currentItem.title}
//           </h5>
//           <div className="d-flex align-items-center gap-2 flex-wrap mt-1">
          
//             <div
//               className="d-flex align-items-center gap-1 px-2 py-1"
//               style={{
//                 background: vegBg,
//                 borderRadius: "8px",
//                 fontSize: "11px",
//                 fontWeight: 700,
//                 color: vegColor,
//               }}
//             >
//               <VegIcon size={12} color={vegColor} />
//               {vegLabel}
//             </div>
//           </div>
//         </div>

//         <div className="text-end d-flex flex-column align-items-end deal-price-col">
//           {currentItem.item_old_price && (
//             <span
//               className="text-muted text-decoration-line-through original-price-tag mb-0.5"
//               style={{ fontSize: "12px", fontWeight: 500 }}
//             >
//               ₹{currentItem.item_old_price}
//             </span>
//           )}
//           <span
//             className="fw-bold deal-new-price"
//             style={{
//               color: "#5dc5fa",
//               fontSize: "26px",
//               fontWeight: "800",
//               lineHeight: "1",
//               letterSpacing: "-0.5px",
//             }}
//           >
//             ₹{currentItem.item_new_price}
//           </span>
//         </div>
//       </div>

//       {/* Bottom Action – Add to Cart with Icon */}
//       <div
//         className="mt-auto w-100 d-flex justify-content-end border-top deal-cta-area"
//         style={{
//           borderColor: "rgba(0,0,0,0.05)",
//           paddingTop: "1.5rem",
//         }}
//       >
//         <button
//           className="btn text-white fw-bold px-4 py-2 shadow-none premium-cta-pills deal-cta-btn d-flex align-items-center gap-2"
//           style={{
//             background: "linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%)",
//             borderRadius: "14px",
//             border: "none",
//             fontSize: "14px",
//             paddingLeft: "28px",
//             paddingRight: "28px",
//             transition: "all 0.25s ease",
//             boxShadow: "0 8px 18px rgba(241, 114, 40, 0.35)",
//           }}
//           onClick={(e) => onOrderNow(e, currentItem.id)}
//           disabled={currentItem.stock === 0}
//         >
//           <FaShoppingCart size={14} />
//           {currentItem.stock === 0 ? "Out of Stock" : "Add to Cart"}
//         </button>
//       </div>

//       <style>{`
//         .deals-premium-card-popup:hover {
//           transform: translateY(-6px);
//           box-shadow:
//             0 32px 70px -10px rgba(0, 0, 0, 0.18),
//             0 10px 35px -2px rgba(0, 0, 0, 0.06) !important;
//           border-color: rgba(241, 114, 40, 0.2) !important;
//         }
//         .premium-arrow-nav {
//           transition: all 0.25s ease !important;
//           opacity: 0.9;
//         }
//         .premium-arrow-nav:hover {
//           background: linear-gradient(135deg, #5dc5fa, #5dc5fa) !important;
//           transform: translateY(-50%) scale(1.08) !important;
//           box-shadow: 0 6px 18px rgba(241, 114, 40, 0.45) !important;
//         }
//         .premium-arrow-nav:hover svg {
//           fill: #ffffff !important;
//         }
//         .premium-cta-pills:hover {
//           background: linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%) !important;
//           box-shadow: 0 10px 22px rgba(241, 114, 40, 0.5) !important;
//           transform: scale(1.02);
//         }

//         /* Default Top Badges Flex Container */
//         .deal-badges-meta-container {
//           position: absolute;
//           top: 16px;
//           left: 16px;
//           right: 16px;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           z-index: 10;
//           pointer-events: none;
//         }
//         .deal-badge-left, .deal-badge-right {
//           pointer-events: auto;
//         }

//         /* Persistent Solid Color Pulsing Animation Rule */
//         .deal-badge-right {
//           animation: badgePulse 2s infinite ease-in-out;
//         }

//         @keyframes badgePulse {
//           0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5); }
//           50% { transform: scale(1.03); box-shadow: 0 0 0 10px rgba(33, 37, 41, 0); }
//           100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(33, 37, 41, 0); }
//         }

//         /* ✨ Polished shine – one clean sweep */
//         .premium-shine-frame::after {
//           content: "";
//           position: absolute;
//           top: -150%;
//           left: -150%;
//           width: 200%;
//           height: 200%;
//           background: linear-gradient(
//             105deg,
//             transparent 40%,
//             rgba(255, 255, 255, 0.3) 45%,
//             rgba(255, 255, 255, 0.7) 50%,
//             rgba(255, 255, 255, 0.3) 55%,
//             transparent 60%
//           );
//           transform: rotate(25deg);
//           animation: shineSweep 0.7s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
//           pointer-events: none;
//           z-index: 3;
//         }

//         @keyframes shineSweep {
//           0% { top: -150%; left: -150%; }
//           100% { top: 150%; left: 150%; }
//         }

//         /* ---------- RESPONSIVE RULES ---------- */
//         @media (max-width: 767.98px) {
//           .deals-card {
//             padding: 1.2rem !important;
//             border-radius: 20px !important;
//           }
//           .deal-image-wrapper {
//             height: 200px !important;
//             border-radius: 16px !important;
//           }
//           .deal-item-title {
//             font-size: 15px !important;
//           }
//           .deal-new-price {
//             font-size: 22px !important;
//           }
//           .deal-cta-area {
//             padding-top: 1rem !important;
//           }
//           .deal-cta-btn {
//             font-size: 13px !important;
//             padding-left: 20px !important;
//             padding-right: 20px !important;
//             border-radius: 12px !important;
//           }
          
//           .deal-badges-meta-container {
//             top: 10px !important;
//             left: 10px !important;
//             right: 10px !important;
//             flex-direction: row !important;
//             align-items: center !important;
//             justify-content: space-between !important;
//           }
//           .deal-badge-left {
//             padding: 5px 10px !important;
//           }
//           .deal-badge-text {
//             font-size: 12px !important;
//           }
//           .deal-badge-right {
//             padding: 5px 10px !important;
//             font-size: 10px !important;
//             background: #212529 !important;
//           }
//           .deal-discount-tag {
//             font-size: 12px !important;
//             padding: 4px 12px !important;
//             bottom: 10px !important;
//             left: 10px !important;
//           }
//           .arrow-left, .arrow-right {
//             width: 32px !important;
//             height: 30px !important;
//           }
//         }

//         @media (max-width: 575.98px) {
//           .deal-image-wrapper {
//             height: 180px !important;
//           }
//           .deal-info-row {
//             flex-direction: column !important;
//             align-items: flex-start !important;
//           }
//           .deal-title-col {
//             max-width: 100% !important;
//             margin-bottom: 0.5rem;
//           }
//           .deal-price-col {
//             align-items: flex-start !important;
//             width: 100%;
//             flex-direction: row !important;
//             justify-content: space-between;
//           }
//           .deal-new-price {
//             font-size: 20px !important;
//           }
//           .deal-cta-btn {
//             width: 100%;
//             justify-content: center;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default DealsOfTheDay;

// DealsOfTheDay.jsx - Updated with View All button

// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import {
//   FaChevronLeft,
//   FaChevronRight,
//   FaTags,
//   FaFire,
//   FaStore,
//   FaShoppingCart,
//   FaLeaf,
//   FaDrumstickBite,
//   FaStar,
//   FaArrowRight,
// } from "react-icons/fa";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";

// function DealsOfTheDay({ refreshCart, selectedBrands = [] }) {
//   const [products, setProducts] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const uid = localStorage.getItem("user_id");

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       let url = "https://backend.frozenwala.com/api/deal-of-the-day/";
//       if (selectedBrands && selectedBrands.length > 0) {
//         url += `?brand=${encodeURIComponent(selectedBrands.join(","))}`;
//       }
//       const res = await fetch(url);
//       const data = await res.json();
//       setProducts(Array.isArray(data) ? data : []);
//       setCurrentIndex(0);
//     } catch (err) {
//       console.error("Error loading deals:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrev = (e) => {
//     e.stopPropagation();
//     if (products.length === 0) return;
//     setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
//   };

//   const handleNext = (e) => {
//     e.stopPropagation();
//     if (products.length === 0) return;
//     setCurrentIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
//   };

//   const onOrderNow = async (e, productId) => {
//     e.stopPropagation();
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       refreshCart();
//       navigate("/cart");
//     } catch (err) {
//       console.error("Quick order failure", err);
//     }
//   };

//   const handleViewAll = () => {
//     navigate('/deals-of-the-day', { 
//       state: { 
//         products: products,
//         selectedBrands: selectedBrands
//       } 
//     });
//   };

//   if (loading) {
//     return (
//       <div
//         className="card h-100 border-0 p-4 deals-card"
//         style={{
//           borderRadius: "28px",
//           minHeight: "440px",
//           backgroundColor: "#fff",
//           boxShadow: "0 25px 50px -12px rgba(0,0,0,0.08)",
//         }}
//       >
//         <div
//           className="placeholder-glow w-50 mb-3"
//           style={{ height: "24px", background: "#f0f0f0", borderRadius: "6px" }}
//         />
//         <div
//           className="w-100 flex-grow-1"
//           style={{ background: "#f8f9fa", borderRadius: "20px" }}
//         />
//       </div>
//     );
//   }

//   if (products.length === 0) return null;
//   const currentItem = products[currentIndex];

//   // Helper for veg/non-veg
//   const isNonVeg = currentItem.non_veg === true;
//   const VegIcon = isNonVeg ? FaDrumstickBite : FaLeaf;
//   const vegColor = isNonVeg ? "#5dc5fa" : "#2e7d32";
//   const vegLabel = isNonVeg ? "Non-Veg" : "Veg";
//   const vegBg = isNonVeg ? "rgba(211,47,47,0.1)" : "rgba(46,125,50,0.1)";

//   return (
//     <>
//       {/* Header with View All button */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div className="d-flex align-items-center gap-3">
//           <h4 className="fw-bold mb-0" style={{ color: "#1a1a2e", fontSize: "1.25rem" }}>
//             Deals of the Day
//           </h4>
         
//         </div>
//         <button
//           onClick={handleViewAll}
//           className="view-all-deals-btn"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//             background: "transparent",
//             border: "2px solid #5dc5fa",
//             borderRadius: "50px",
//             padding: "6px 18px",
//             fontSize: "13px",
//             fontWeight: 700,
//             color: "#5dc5fa",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             whiteSpace: "nowrap",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.background = "#5dc5fa";
//             e.currentTarget.style.color = "#fff";
//             e.currentTarget.style.transform = "translateX(4px)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.background = "transparent";
//             e.currentTarget.style.color = "#5dc5fa";
//             e.currentTarget.style.transform = "translateX(0)";
//           }}
//         >
//           View All <FaArrowRight size={12} />
//         </button>
//       </div>

//       <div
//         className="card h-100 border-0 p-4 deals-premium-card-popup deals-card"
//         style={{
//           borderRadius: "28px",
//           background:
//             "linear-gradient(145deg, #ffffff 0%, #fafbfc 100%)",
//           cursor: "pointer",
//           boxShadow:
//             "0 25px 60px -15px rgba(0, 0, 0, 0.12), 0 4px 20px -2px rgba(0, 0, 0, 0.03)",
//           border: "1px solid rgba(241, 114, 40, 0.08)",
//           transition:
//             "transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
//           position: "relative",
//           overflow: "visible",
//         }}
//         onClick={() => navigate(`products/${currentItem.id}`)}
//       >
//         {/* Subtle glow background accent */}
//         <div
//           style={{
//             position: "absolute",
//             top: "-40px",
//             right: "-30px",
//             width: "120px",
//             height: "120px",
//             background:
//               "radial-gradient(circle, rgba(241,114,40,0.15) 0%, transparent 70%)",
//             borderRadius: "50%",
//             zIndex: 0,
//             pointerEvents: "none",
//           }}
//         />

//         {/* Expanded Vertical Showcase Image Area with polished shine */}
//         <div
//           className="position-relative w-100 mb-4 premium-shine-frame deal-image-wrapper"
//           style={{
//             height: "300px",
//             borderRadius: "20px",
//             overflow: "hidden",
//             boxShadow:
//               "0 12px 28px -6px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.02)",
//             zIndex: 2,
//           }}
//         >
//           {/* Responsive Badge Container */}
//           <div className="deal-badges-meta-container">
//             {/* Glassmorphism Title Overlay – now more vibrant */}
//             <div
//               className="d-flex align-items-center gap-2 deal-badge-left"
//               style={{
//                 background: "rgba(255, 255, 255, 0.85)",
//                 backdropFilter: "blur(16px)",
//                 WebkitBackdropFilter: "blur(16px)",
//                 border: "1px solid rgba(255, 255, 255, 0.5)",
//                 padding: "8px 16px",
//                 borderRadius: "100px",
//                 boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
//               }}
//             >
//               <motion.div
//                 animate={{ scale: [1, 1.25, 1] }}
//                 transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
//                 style={{ display: "flex", alignItems: "center", transform: "translateY(-2px)" }}
//               >
//                 <FaFire color="#5dc5fa" size={20} />
//               </motion.div>
//               <span
//                 className="fw-bold text-dark deal-badge-text"
//                 style={{ fontSize: "16px", letterSpacing: "-0.2px" }}
//               >
//                 Deals of the Day
//               </span>
//             </div>

//             {/* Limited Offers Status Pill – more vivid */}
//             <div
//               className="d-flex align-items-center gap-1.5 deal-badge-right"
//               style={{
//                 background: "linear-gradient(135deg, #212529 0%, #343a40 100%)",
//                 padding: "8px 14px",
//                 borderRadius: "100px",
//                 color: "#fff",
//                 fontSize: "11px",
//                 fontWeight: "600",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
//               }}
//             >
//               <FaTags size={11} color="#5dc5fa" /> Limited Offers
//             </div>
//           </div>

//           {/* Discount Overlay – ribbon style */}
//           {currentItem.discount_percentage && (
//             <div
//               className="position-absolute text-white fw-bold px-3 py-2 text-center shadow deal-discount-tag"
//               style={{
//                 bottom: "20px",
//                 left: "16px",
//                 background: "linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%)",
//                 borderRadius: "14px",
//                 zIndex: 4,
//                 fontSize: "14px",
//                 letterSpacing: "0.5px",
//                 lineHeight: "1.2",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 boxShadow: "0 8px 18px rgba(241, 114, 40, 0.45)",
//                 border: "1px solid rgba(255,255,255,0.2)",
//               }}
//             >
//               <span style={{ fontSize: "18px", fontWeight: 800 }}>
//                 {currentItem.discount_percentage}%
//               </span>
//               <span style={{ fontSize: "10px", opacity: 0.9 }}>OFF</span>
//               <FaStar
//                 size={10}
//                 style={{ position: "absolute", top: "-6px", right: "-6px", color: "#FFD700" }}
//               />
//             </div>
//           )}

//           {products.length > 1 && (
//             <>
//               <button
//                 onClick={handlePrev}
//                 className="btn d-flex align-items-center justify-content-center p-0 shadow premium-arrow-nav arrow-left"
//                 style={{
//                   position: "absolute",
//                   left: "14px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   width: "38px",
//                   height: "36px",
//                   borderRadius: "50%",
//                   zIndex: 5,
//                   border: "none",
//                   backgroundColor: "#ffffff",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                 }}
//               >
//                 <FaChevronLeft size={11} color="#212529" />
//               </button>
//               <button
//                 onClick={handleNext}
//                 className="btn d-flex align-items-center justify-content-center p-0 shadow premium-arrow-nav arrow-right"
//                 style={{
//                   position: "absolute",
//                   right: "14px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   width: "38px",
//                   height: "36px",
//                   borderRadius: "50%",
//                   zIndex: 5,
//                   border: "none",
//                   backgroundColor: "#ffffff",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                 }}
//               >
//                 <FaChevronRight size={11} color="#212529" />
//               </button>
//             </>
//           )}

//           <AnimatePresence mode="wait">
//             <motion.img
//               key={currentItem.id}
//               src={currentItem.item_photo || logo}
//               alt={currentItem.title}
//               className="w-100 h-100"
//               style={{ objectFit: "cover" }}
//               initial={{ opacity: 0, scale: 1.03 }}
//               animate={{ opacity: 1, scale: 1 }}
//               exit={{ opacity: 0, scale: 0.97 }}
//               transition={{ duration: 0.25 }}
//             />
//           </AnimatePresence>
//         </div>

//         {/* Structured Content Metadata */}
//         <div className="d-flex justify-content-between align-items-start px-1 mb-2 deal-info-row">
//           <div className="deal-title-col" style={{ maxWidth: "70%", flex: 1 }}>
//             <h5
//               className="fw-bold text-dark mb-1 deal-item-title"
//               style={{
//                 fontSize: "17px",
//                 letterSpacing: "-0.2px",
//                 lineHeight: 1.3,
//                 display: "-webkit-box",
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//               }}
//             >
//               {currentItem.title}
//             </h5>
//             <div className="d-flex align-items-center gap-2 flex-wrap mt-1">
//               <div
//                 className="d-flex align-items-center gap-1 px-2 py-1"
//                 style={{
//                   borderRadius: "8px",
//                   fontSize: "11px",
//                   fontWeight: 700,
//                 }}
//               >
               
//                 Brand : {currentItem.brand_name}
//               </div>
//             </div>
//           </div>

//           <div className="text-end d-flex flex-column align-items-end deal-price-col">
//             {currentItem.item_old_price && (
//               <span
//                 className="text-muted text-decoration-line-through original-price-tag mb-0.5"
//                 style={{ fontSize: "12px", fontWeight: 500 }}
//               >
//                 ₹{currentItem.item_old_price}
//               </span>
//             )}
//             <span
//               className="fw-bold deal-new-price"
//               style={{
//                 color: "#5dc5fa",
//                 fontSize: "26px",
//                 fontWeight: "800",
//                 lineHeight: "1",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               ₹{currentItem.item_new_price}
//             </span>
//           </div>
//         </div>

//         {/* Bottom Action – Add to Cart with Icon */}
//         <div
//           className="mt-auto w-100 d-flex justify-content-end border-top deal-cta-area"
//           style={{
//             borderColor: "rgba(0,0,0,0.05)",
//             paddingTop: "1.5rem",
//           }}
//         >
//           <button
//             className="btn text-white fw-bold px-4 py-2 shadow-none premium-cta-pills deal-cta-btn d-flex align-items-center gap-2"
//             style={{
//               background: "linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%)",
//               borderRadius: "14px",
//               border: "none",
//               fontSize: "14px",
//               paddingLeft: "28px",
//               paddingRight: "28px",
//               transition: "all 0.25s ease",
//               boxShadow: "0 8px 18px rgba(241, 114, 40, 0.35)",
//             }}
//             onClick={(e) => onOrderNow(e, currentItem.id)}
//             disabled={currentItem.stock === 0}
//           >
//             <FaShoppingCart size={14} />
//             {currentItem.stock === 0 ? "Out of Stock" : "Add to Cart"}
//           </button>
//         </div>

//         <style>{`
//           .deals-premium-card-popup:hover {
//             transform: translateY(-6px);
//             box-shadow:
//               0 32px 70px -10px rgba(0, 0, 0, 0.18),
//               0 10px 35px -2px rgba(0, 0, 0, 0.06) !important;
//             border-color: rgba(241, 114, 40, 0.2) !important;
//           }
//           .premium-arrow-nav {
//             transition: all 0.25s ease !important;
//             opacity: 0.9;
//           }
//           .premium-arrow-nav:hover {
//             background: linear-gradient(135deg, #5dc5fa, #5dc5fa) !important;
//             transform: translateY(-50%) scale(1.08) !important;
//             box-shadow: 0 6px 18px rgba(241, 114, 40, 0.45) !important;
//           }
//           .premium-arrow-nav:hover svg {
//             fill: #ffffff !important;
//           }
//           .premium-cta-pills:hover {
//             background: linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%) !important;
//             box-shadow: 0 10px 22px rgba(241, 114, 40, 0.5) !important;
//             transform: scale(1.02);
//           }

//           /* Default Top Badges Flex Container */
//           .deal-badges-meta-container {
//             position: absolute;
//             top: 16px;
//             left: 16px;
//             right: 16px;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             z-index: 10;
//             pointer-events: none;
//           }
//           .deal-badge-left, .deal-badge-right {
//             pointer-events: auto;
//           }

//           /* Persistent Solid Color Pulsing Animation Rule */
//           .deal-badge-right {
//             animation: badgePulse 2s infinite ease-in-out;
//           }

//           @keyframes badgePulse {
//             0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5); }
//             50% { transform: scale(1.03); box-shadow: 0 0 0 10px rgba(33, 37, 41, 0); }
//             100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(33, 37, 41, 0); }
//           }

//           /* ✨ Polished shine – one clean sweep */
//           .premium-shine-frame::after {
//             content: "";
//             position: absolute;
//             top: -150%;
//             left: -150%;
//             width: 200%;
//             height: 200%;
//             background: linear-gradient(
//               105deg,
//               transparent 40%,
//               rgba(255, 255, 255, 0.3) 45%,
//               rgba(255, 255, 255, 0.7) 50%,
//               rgba(255, 255, 255, 0.3) 55%,
//               transparent 60%
//             );
//             transform: rotate(25deg);
//             animation: shineSweep 0.7s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
//             pointer-events: none;
//             z-index: 3;
//           }

//           @keyframes shineSweep {
//             0% { top: -150%; left: -150%; }
//             100% { top: 150%; left: 150%; }
//           }

//           /* ---------- RESPONSIVE RULES ---------- */
//           @media (max-width: 767.98px) {
//             .deals-card {
//               padding: 1.2rem !important;
//               border-radius: 20px !important;
//             }
//             .deal-image-wrapper {
//               height: 200px !important;
//               border-radius: 16px !important;
//             }
//             .deal-item-title {
//               font-size: 15px !important;
//             }
//             .deal-new-price {
//               font-size: 22px !important;
//             }
//             .deal-cta-area {
//               padding-top: 1rem !important;
//             }
//             .deal-cta-btn {
//               font-size: 13px !important;
//               padding-left: 20px !important;
//               padding-right: 20px !important;
//               border-radius: 12px !important;
//             }
            
//             .deal-badges-meta-container {
//               top: 10px !important;
//               left: 10px !important;
//               right: 10px !important;
//               flex-direction: row !important;
//               align-items: center !important;
//               justify-content: space-between !important;
//             }
//             .deal-badge-left {
//               padding: 5px 10px !important;
//             }
//             .deal-badge-text {
//               font-size: 12px !important;
//             }
//             .deal-badge-right {
//               padding: 5px 10px !important;
//               font-size: 10px !important;
//               background: #212529 !important;
//             }
//             .deal-discount-tag {
//               font-size: 12px !important;
//               padding: 4px 12px !important;
//               bottom: 10px !important;
//               left: 10px !important;
//             }
//             .arrow-left, .arrow-right {
//               width: 32px !important;
//               height: 30px !important;
//             }
//           }

//           @media (max-width: 575.98px) {
//             .deal-image-wrapper {
//               height: 180px !important;
//             }
//             .deal-info-row {
//               flex-direction: column !important;
//               align-items: flex-start !important;
//             }
//             .deal-title-col {
//               max-width: 100% !important;
//               margin-bottom: 0.5rem;
//             }
//             .deal-price-col {
//               align-items: flex-start !important;
//               width: 100%;
//               flex-direction: row !important;
//               justify-content: space-between;
//             }
//             .deal-new-price {
//               font-size: 20px !important;
//             }
//             .deal-cta-btn {
//               width: 100%;
//               justify-content: center;
//             }
//           }
//         `}</style>
//       </div>
//     </>
//   );
// }

// export default DealsOfTheDay;

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  FaChevronLeft,
  FaChevronRight,
  FaTags,
  FaFire,
  FaStore,
  FaShoppingCart,
  FaLeaf,
  FaDrumstickBite,
  FaStar,
  FaArrowRight,
} from "react-icons/fa";
import Api from "../Utills/Api";
import logo from "../../Frozenwala.png";
import ProductModal from "./ProductModal"; // Add this import

function DealsOfTheDay({ refreshCart, selectedBrands = [] }) {
  const [products, setProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  
  // Modal states - Add these
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const navigate = useNavigate();
  const uid = localStorage.getItem("user_id");

  useEffect(() => {
    fetchData();
  }, [selectedBrands]);

  const fetchData = async () => {
    try {
      setLoading(true);
      let url = "https://backend.frozenwala.com/api/deal-of-the-day/";
      if (selectedBrands && selectedBrands.length > 0) {
        url += `?brand=${encodeURIComponent(selectedBrands.join(","))}`;
      }
      const res = await fetch(url);
      const data = await res.json();
      setProducts(Array.isArray(data) ? data : []);
      setCurrentIndex(0);
    } catch (err) {
      console.error("Error loading deals:", err);
    } finally {
      setLoading(false);
    }
  };

  // Add modal handlers
  const handleProductClick = (productId) => {
    setSelectedProductId(productId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProductId(null);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    if (products.length === 0) return;
    setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    if (products.length === 0) return;
    setCurrentIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
  };

  const onOrderNow = async (e, productId) => {
    e.stopPropagation();
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    try {
      await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
      refreshCart();
      navigate("/cart");
    } catch (err) {
      console.error("Quick order failure", err);
    }
  };

  const handleViewAll = () => {
    navigate('/deals-of-the-day', { 
      state: { 
        products: products,
        selectedBrands: selectedBrands
      } 
    });
  };

  if (loading) {
    return (
      <div
        className="card h-100 border-0 p-4 deals-card"
        style={{
          borderRadius: "28px",
          minHeight: "440px",
          backgroundColor: "#fff",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.08)",
        }}
      >
        <div
          className="placeholder-glow w-50 mb-3"
          style={{ height: "24px", background: "#f0f0f0", borderRadius: "6px" }}
        />
        <div
          className="w-100 flex-grow-1"
          style={{ background: "#f8f9fa", borderRadius: "20px" }}
        />
      </div>
    );
  }

  if (products.length === 0) return null;
  const currentItem = products[currentIndex];

  // Helper for veg/non-veg
  const isNonVeg = currentItem.non_veg === true;
  const VegIcon = isNonVeg ? FaDrumstickBite : FaLeaf;
  const vegColor = isNonVeg ? "#5dc5fa" : "#2e7d32";
  const vegLabel = isNonVeg ? "Non-Veg" : "Veg";
  const vegBg = isNonVeg ? "rgba(211,47,47,0.1)" : "rgba(46,125,50,0.1)";

  return (
    <>
      {/* Product Modal */}
      <ProductModal
        isOpen={isModalOpen}
        productId={selectedProductId}
        onClose={handleCloseModal}
        refreshCart={refreshCart}
      />

      {/* Header with View All button */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-3">
          <h4 className="fw-bold mb-0" style={{ color: "#1a1a2e", fontSize: "1.25rem" }}>
            Deals of the Day
          </h4>
         
        </div>
        <button
          onClick={handleViewAll}
          className="view-all-deals-btn"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "transparent",
            border: "2px solid #5dc5fa",
            borderRadius: "50px",
            padding: "6px 18px",
            fontSize: "13px",
            fontWeight: 700,
            color: "#5dc5fa",
            cursor: "pointer",
            transition: "all 0.3s ease",
            whiteSpace: "nowrap",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#5dc5fa";
            e.currentTarget.style.color = "#fff";
            e.currentTarget.style.transform = "translateX(4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = "#5dc5fa";
            e.currentTarget.style.transform = "translateX(0)";
          }}
        >
          View All <FaArrowRight size={12} />
        </button>
      </div>

      <div
        className="card h-100 border-0 p-4 deals-premium-card-popup deals-card"
        style={{
          borderRadius: "28px",
          background:
            "linear-gradient(145deg, #ffffff 0%, #fafbfc 100%)",
          cursor: "pointer",
          boxShadow:
            "0 25px 60px -15px rgba(0, 0, 0, 0.12), 0 4px 20px -2px rgba(0, 0, 0, 0.03)",
          border: "1px solid rgba(241, 114, 40, 0.08)",
          transition:
            "transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
          position: "relative",
          overflow: "visible",
        }}
        // Replace navigation with modal handler
        onClick={() => handleProductClick(currentItem.id)}
      >
        {/* Subtle glow background accent */}
        <div
          style={{
            position: "absolute",
            top: "-40px",
            right: "-30px",
            width: "120px",
            height: "120px",
            background:
              "radial-gradient(circle, rgba(241,114,40,0.15) 0%, transparent 70%)",
            borderRadius: "50%",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        {/* Expanded Vertical Showcase Image Area with polished shine */}
        <div
          className="position-relative w-100 mb-4 premium-shine-frame deal-image-wrapper"
          style={{
            height: "300px",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow:
              "0 12px 28px -6px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.02)",
            zIndex: 2,
          }}
        >
          {/* Responsive Badge Container */}
          <div className="deal-badges-meta-container">
            {/* Glassmorphism Title Overlay – now more vibrant */}
            <div
              className="d-flex align-items-center gap-2 deal-badge-left"
              style={{
                background: "rgba(255, 255, 255, 0.85)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                border: "1px solid rgba(255, 255, 255, 0.5)",
                padding: "8px 16px",
                borderRadius: "100px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
              }}
            >
              <motion.div
                animate={{ scale: [1, 1.25, 1] }}
                transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                style={{ display: "flex", alignItems: "center", transform: "translateY(-2px)" }}
              >
                <FaFire color="#5dc5fa" size={20} />
              </motion.div>
              <span
                className="fw-bold text-dark deal-badge-text"
                style={{ fontSize: "16px", letterSpacing: "-0.2px" }}
              >
                Deals of the Day
              </span>
            </div>

            {/* Limited Offers Status Pill – more vivid */}
            <div
              className="d-flex align-items-center gap-1.5 deal-badge-right"
              style={{
                background: "linear-gradient(135deg, #212529 0%, #343a40 100%)",
                padding: "8px 14px",
                borderRadius: "100px",
                color: "#fff",
                fontSize: "11px",
                fontWeight: "600",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              }}
            >
              <FaTags size={11} color="#5dc5fa" /> Limited Offers
            </div>
          </div>

          {/* Discount Overlay – ribbon style */}
          {currentItem.discount_percentage && (
            <div
              className="position-absolute text-white fw-bold px-3 py-2 text-center shadow deal-discount-tag"
              style={{
                bottom: "20px",
                left: "16px",
                background: "linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%)",
                borderRadius: "14px",
                zIndex: 4,
                fontSize: "14px",
                letterSpacing: "0.5px",
                lineHeight: "1.2",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0 8px 18px rgba(241, 114, 40, 0.45)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <span style={{ fontSize: "18px", fontWeight: 800 }}>
                {currentItem.discount_percentage}%
              </span>
              <span style={{ fontSize: "10px", opacity: 0.9 }}>OFF</span>
              <FaStar
                size={10}
                style={{ position: "absolute", top: "-6px", right: "-6px", color: "#FFD700" }}
              />
            </div>
          )}

          {products.length > 1 && (
            <>
              <button
                onClick={handlePrev}
                className="btn d-flex align-items-center justify-content-center p-0 shadow premium-arrow-nav arrow-left"
                style={{
                  position: "absolute",
                  left: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "38px",
                  height: "36px",
                  borderRadius: "50%",
                  zIndex: 5,
                  border: "none",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                <FaChevronLeft size={11} color="#212529" />
              </button>
              <button
                onClick={handleNext}
                className="btn d-flex align-items-center justify-content-center p-0 shadow premium-arrow-nav arrow-right"
                style={{
                  position: "absolute",
                  right: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "38px",
                  height: "36px",
                  borderRadius: "50%",
                  zIndex: 5,
                  border: "none",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                <FaChevronRight size={11} color="#212529" />
              </button>
            </>
          )}

          <AnimatePresence mode="wait">
            <motion.img
              key={currentItem.id}
              src={currentItem.item_photo || logo}
              alt={currentItem.title}
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
              initial={{ opacity: 0, scale: 1.03 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.97 }}
              transition={{ duration: 0.25 }}
            />
          </AnimatePresence>
        </div>

        {/* Structured Content Metadata */}
        <div className="d-flex justify-content-between align-items-start px-1 mb-2 deal-info-row">
          <div className="deal-title-col" style={{ maxWidth: "70%", flex: 1 }}>
            <h5
              className="fw-bold text-dark mb-1 deal-item-title"
              style={{
                fontSize: "17px",
                letterSpacing: "-0.2px",
                lineHeight: 1.3,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                cursor: "pointer"
              }}
              // Add click handler to title
              onClick={(e) => {
                e.stopPropagation();
                handleProductClick(currentItem.id);
              }}
            >
              {currentItem.title}
            </h5>
            <div className="d-flex align-items-center gap-2 flex-wrap mt-1">
              <div
                className="d-flex align-items-center gap-1 px-2 py-1"
                style={{
                  borderRadius: "8px",
                  fontSize: "11px",
                  fontWeight: 700,
                }}
              >
               
                Brand : {currentItem.brand_name}
              </div>
            </div>
          </div>

          <div className="text-end d-flex flex-column align-items-end deal-price-col">
            {currentItem.item_old_price && (
              <span
                className="text-muted text-decoration-line-through original-price-tag mb-0.5"
                style={{ fontSize: "12px", fontWeight: 500 }}
              >
                ₹{currentItem.item_old_price}
              </span>
            )}
            <span
              className="fw-bold deal-new-price"
              style={{
                color: "#5dc5fa",
                fontSize: "26px",
                fontWeight: "800",
                lineHeight: "1",
                letterSpacing: "-0.5px",
              }}
            >
              ₹{currentItem.item_new_price}
            </span>
          </div>
        </div>

        {/* Bottom Action – Add to Cart with Icon */}
        <div
          className="mt-auto w-100 d-flex justify-content-end border-top deal-cta-area"
          style={{
            borderColor: "rgba(0,0,0,0.05)",
            paddingTop: "1.5rem",
          }}
        >
          <button
            className="btn text-white fw-bold px-4 py-2 shadow-none premium-cta-pills deal-cta-btn d-flex align-items-center gap-2"
            style={{
              background: "linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%)",
              borderRadius: "14px",
              border: "none",
              fontSize: "14px",
              paddingLeft: "28px",
              paddingRight: "28px",
              transition: "all 0.25s ease",
              boxShadow: "0 8px 18px rgba(241, 114, 40, 0.35)",
            }}
            onClick={(e) => onOrderNow(e, currentItem.id)}
            disabled={currentItem.stock === 0}
          >
            <FaShoppingCart size={14} />
            {currentItem.stock === 0 ? "Out of Stock" : "Add to Cart"}
          </button>
        </div>

        <style>{`
          .deals-premium-card-popup:hover {
            transform: translateY(-6px);
            box-shadow:
              0 32px 70px -10px rgba(0, 0, 0, 0.18),
              0 10px 35px -2px rgba(0, 0, 0, 0.06) !important;
            border-color: rgba(241, 114, 40, 0.2) !important;
          }
          .premium-arrow-nav {
            transition: all 0.25s ease !important;
            opacity: 0.9;
          }
          .premium-arrow-nav:hover {
            background: linear-gradient(135deg, #5dc5fa, #5dc5fa) !important;
            transform: translateY(-50%) scale(1.08) !important;
            box-shadow: 0 6px 18px rgba(241, 114, 40, 0.45) !important;
          }
          .premium-arrow-nav:hover svg {
            fill: #ffffff !important;
          }
          .premium-cta-pills:hover {
            background: linear-gradient(135deg, #5dc5fa 0%, #5dc5fa 100%) !important;
            box-shadow: 0 10px 22px rgba(241, 114, 40, 0.5) !important;
            transform: scale(1.02);
          }

          /* Default Top Badges Flex Container */
          .deal-badges-meta-container {
            position: absolute;
            top: 16px;
            left: 16px;
            right: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            z-index: 10;
            pointer-events: none;
          }
          .deal-badge-left, .deal-badge-right {
            pointer-events: auto;
          }

          /* Persistent Solid Color Pulsing Animation Rule */
          .deal-badge-right {
            animation: badgePulse 2s infinite ease-in-out;
          }

          @keyframes badgePulse {
            0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5); }
            50% { transform: scale(1.03); box-shadow: 0 0 0 10px rgba(33, 37, 41, 0); }
            100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(33, 37, 41, 0); }
          }

          /* ✨ Polished shine – one clean sweep */
          .premium-shine-frame::after {
            content: "";
            position: absolute;
            top: -150%;
            left: -150%;
            width: 200%;
            height: 200%;
            background: linear-gradient(
              105deg,
              transparent 40%,
              rgba(255, 255, 255, 0.3) 45%,
              rgba(255, 255, 255, 0.7) 50%,
              rgba(255, 255, 255, 0.3) 55%,
              transparent 60%
            );
            transform: rotate(25deg);
            animation: shineSweep 0.7s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
            pointer-events: none;
            z-index: 3;
          }

          @keyframes shineSweep {
            0% { top: -150%; left: -150%; }
            100% { top: 150%; left: 150%; }
          }

          /* ---------- RESPONSIVE RULES ---------- */
          @media (max-width: 767.98px) {
            .deals-card {
              padding: 1.2rem !important;
              border-radius: 20px !important;
            }
            .deal-image-wrapper {
              height: 200px !important;
              border-radius: 16px !important;
            }
            .deal-item-title {
              font-size: 15px !important;
            }
            .deal-new-price {
              font-size: 22px !important;
            }
            .deal-cta-area {
              padding-top: 1rem !important;
            }
            .deal-cta-btn {
              font-size: 13px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
              border-radius: 12px !important;
            }
            
            .deal-badges-meta-container {
              top: 10px !important;
              left: 10px !important;
              right: 10px !important;
              flex-direction: row !important;
              align-items: center !important;
              justify-content: space-between !important;
            }
            .deal-badge-left {
              padding: 5px 10px !important;
            }
            .deal-badge-text {
              font-size: 12px !important;
            }
            .deal-badge-right {
              padding: 5px 10px !important;
              font-size: 10px !important;
              background: #212529 !important;
            }
            .deal-discount-tag {
              font-size: 12px !important;
              padding: 4px 12px !important;
              bottom: 10px !important;
              left: 10px !important;
            }
            .arrow-left, .arrow-right {
              width: 32px !important;
              height: 30px !important;
            }
          }

          @media (max-width: 575.98px) {
            .deal-image-wrapper {
              height: 180px !important;
            }
            .deal-info-row {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            .deal-title-col {
              max-width: 100% !important;
              margin-bottom: 0.5rem;
            }
            .deal-price-col {
              align-items: flex-start !important;
              width: 100%;
              flex-direction: row !important;
              justify-content: space-between;
            }
            .deal-new-price {
              font-size: 20px !important;
            }
            .deal-cta-btn {
              width: 100%;
              justify-content: center;
            }
          }
        `}</style>
      </div>
    </>
  );
}

export default DealsOfTheDay;